import React from "react";
import { Alert } from "react-bootstrap";
import SntWarningIcon from "@icons/SntWarningIcon";

interface SntWarningInfoProps {
  className?: string;
  children?: React.ReactNode;
  iconClassName?: string;
}

const SntWarningInfo: React.FC<SntWarningInfoProps> = ({
  className = "",
  children,
  iconClassName = "",
}) => {
  return (
    <Alert
      style={{
        backgroundColor: "#fff3cd",
        border: "1px solid #FFA858",
        color: "#304269",
      }}
      className={className}
    >
      <div className="d-flex">
        <div style={{ minWidth: 24 }} className={iconClassName}>
          <SntWarningIcon />
        </div>
        <div className="flex-grow-1">{children}</div>
      </div>
    </Alert>
  );
};

export default SntWarningInfo;
